<template>
  <div class="container">
    <h1 class="title is-size-4-mobile">{{ $t("Account settings") }}</h1>
    <field-horizontal :label="$t('Language')">
      <select-field
        @change="selectLang"
        :options="$i18n.getLocales()"
        :value="lang"
      />
    </field-horizontal>
    <field-horizontal v-if="isUserProviderPassword" :label="$t('Password')">
      <reset-password-button :email="email" :label="$t('Change password')" />
    </field-horizontal>
  </div>
</template>

<script>
import { state, actions } from "@/store"
import {
  FieldHorizontal,
  SelectField,
  ResetPasswordButton
} from "@/components/form"

export default {
  name: "account-settings",
  components: {
    FieldHorizontal,
    SelectField,
    ResetPasswordButton
  },
  computed: {
    email() {
      return state.user.email
    },
    isUserProviderPassword() {
      return state.user.providerId === "password" || !state.user.providerId
    },
    lang() {
      return state.lang
    }
  },
  methods: {
    selectLang(lang) {
      actions.clearErrors()
      actions
        .setLangToUser(state.user.email, lang)
        .catch(actions.addError("set-lang-error"))
    }
  }
}
</script>
